import { render, staticRenderFns } from "./detailStore.vue?vue&type=template&id=1f336b3e&scoped=true&"
import script from "./detailStore.vue?vue&type=script&lang=js&"
export * from "./detailStore.vue?vue&type=script&lang=js&"
import style0 from "./detailStore.vue?vue&type=style&index=0&id=1f336b3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f336b3e",
  null
  
)

export default component.exports